import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DocumentTypes } from "src/app/models/documentTypes";
import { LegalEntityInstructionFieldQueryModel, LegalEntityInstructionFieldViewModel, LegalEntityInstructionUpdateModel, LegalEntityInstructionUpdateResponse } from "src/app/models/investorUpdate";
import { LegalEntityInstructionService } from "src/app/services/http/legal-entity-instruction.service";

@Injectable()
export class LegalEntityInstructionFacade {
    constructor(private legalEntityInstructionService: LegalEntityInstructionService) { }
    
    public saveInvestorDetailsUpdateInstruction(investorDetails: LegalEntityInstructionUpdateModel): Observable<LegalEntityInstructionUpdateResponse> {
        return this.legalEntityInstructionService.saveInvestorDetailsUpdateInstruction(investorDetails);
    }

    public saveMemberDetailsUpdateInstruction(memberDetails: LegalEntityInstructionUpdateModel): Observable<LegalEntityInstructionUpdateResponse> {
        return this.legalEntityInstructionService.saveMemberDetailsUpdateInstruction(memberDetails);
    }

    public saveMemberDetailsTaxResidenceUpdateInstruction(memberDetails: LegalEntityInstructionUpdateModel): Observable<LegalEntityInstructionUpdateResponse>{
        return this.legalEntityInstructionService.saveMemberDetailsTaxResidenceUpdateInstruction(memberDetails);
    }

    public saveInvestorDetailsUpdateInstructionDocument(file: File, legalEntityId: number, instructionId: number, documentType: DocumentTypes): Observable<any> {
        return this.legalEntityInstructionService.saveLegalEntityDetailsUpdateInstructionDocument(file, legalEntityId, instructionId, documentType);
    }

    public getLegalEntityUpdateInstructions(requestModel: LegalEntityInstructionFieldQueryModel): Observable<LegalEntityInstructionFieldViewModel[]> {
        return this.legalEntityInstructionService.getLegalEntityUpdateInstructions(requestModel);
    }

    public cancelLegalEntityUpdateInstruction(legalEntityId: number, instructionId: number): Observable<any> {
        return this.legalEntityInstructionService.cancelLegalEntityUpdateInstruction(legalEntityId, instructionId);
    }
}